import { atom } from "jotai"

export const helpMenuOpenAtom = atom(false)
